import React from 'react';
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Typography } from '@mui/material';
import './DataTable.css';

export default function DataTable({ columns, data, renderRow, loading }) {
  return (
    <TableContainer component={Paper} sx={styles.tableSX} className="custom-scroll">
      <Table>
        <TableHead>
          <TableRow>
            {columns.map((col, idx) => (
              <TableCell
                key={idx}
                sx={{
                  position: 'sticky',
                  top: 0,
                  backgroundColor: 'white',
                  zIndex: 1,
                }}
              >
                <Typography style={styles.tableTitle}>{col}</Typography>{' '}
              </TableCell>
            ))}
          </TableRow>
        </TableHead>

        <TableBody>{data.map((item, index) => renderRow(item, index))}</TableBody>
      </Table>
      {loading && <Typography sx={{ textAlign: 'center', mt: 2 }}>טוען...</Typography>}
    </TableContainer>
  );
}

const styles = {
  tableTitle: {
    fontWeight: 'bold',
    fontSize: 16,
    color: 'rgb(113, 104, 100)',
    textAlign: 'right',
  },
  head: {
    position: 'absolute',
    top: -20,
    width: '100%',
    maxWidth: '90%',
  },
  tableContainer: {
    position: 'relative',
  },
  tableSX: {
    maxWidth: '90%',
    margin: 'auto',
    mt: 4,
    borderColor: 'lightgrey',
    borderStyle: 'solid',
    borderWidth: 1,
    borderRadius: 3,
    maxHeight: 500,
  },
};
